import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { tryFetch } from '../../../Helpers/FetchAPI';
import '../../../styles/Home.scss';

interface Product {
  id: string;
  product_name: string;
  product_slug: string;
  unit_price: string;
  sale_price: string;
  is_sale: boolean;
  media: { media_url: string }[];
  merchant_slug: string;
}

interface Merchant {
  id: string;
  merchant_name: string;
}

const SaleSection: React.FC = () => {
  const [saleProducts, setSaleProducts] = useState<Product[]>([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const currency = process.env.REACT_APP_CURRENCY;
  const containerRef = React.useRef<HTMLDivElement>(null);
  const [showSeeAll, setShowSeeAll] = useState(false);

  useEffect(() => {
    const fetchSaleProducts = async () => {
      try {
        const merchantRes = await tryFetch({
          url: '/merchants',
          method: 'GET',
        });

        if (!merchantRes.is_success) throw new Error('Failed to fetch merchants');

        const merchants: Merchant[] = Array.isArray(merchantRes.data) ? merchantRes.data as Merchant[] : [];

        const allSaleProducts: Product[] = [];

        await Promise.all(
          merchants.map(async (merchant) => {
            const prodRes = await tryFetch({
              url: `/merchants/${merchant.id}/products`,
              method: 'GET',
              query: '?limit=999',
            });

            if (prodRes.is_success && Array.isArray(prodRes.data)) {
              const merchantSaleProds = prodRes.data.filter((p: Product) => p.is_sale);
              allSaleProducts.push(...merchantSaleProds);
            }
          })
        );

        setSaleProducts(allSaleProducts);
      } catch (err) {
        console.error('Error fetching sale products:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchSaleProducts();
  }, []);

  useEffect(() => {
  const checkOverflowAndCount = () => {
    if (!containerRef.current) return;

    const isOverflowing =
      containerRef.current.scrollWidth > containerRef.current.clientWidth;

    const isMobile = window.innerWidth < 768;
    const minCount = isMobile ? 2 : 5;

    setShowSeeAll(isOverflowing || saleProducts.length >= minCount);
  };

  if (!loading && saleProducts.length) {
    checkOverflowAndCount();
    window.addEventListener('resize', checkOverflowAndCount);
    return () => window.removeEventListener('resize', checkOverflowAndCount);
  }
}, [saleProducts, loading]);

if (!saleProducts.length && !loading) return null;

  return (
    <div className="merchant-sections">
      <div className="merchant-category">
        <div className="category-header">
          <h3>GottSulit</h3>
          {/* {showSeeAll && (
          <button
            className="see-all"
            onClick={() => navigate('s/a/GottSulit')}
          >
            See All
          </button>
        )} */}
        </div>
        <div className="merchant-list-container">
          <div className="merchant-list scrollable" ref={containerRef}>
            {loading ? (
              Array(4).fill(0).map((_, index) => (
                <div key={index} className="merchant-item">
                  <div className="merchant-image-wrapper">
                    <div className="merchant-hero" />
                  </div>
                </div>
              ))
            ) : (
              saleProducts.slice(0, 10).map((product) => (
                <div key={product.id} className="merchant-item">
                  <Link to={`/merchant/${product.merchant_slug}/product/${product.product_slug}`}>
                    <div className="merchant-image-wrapper">
                      <div
                        className="merchant-hero"
                        style={{
                          backgroundImage: `url(${product.media[0]?.media_url || '/default-product.jpg'})`,
                        }}
                      />
                    </div>
                    <p className="product-name">
                      {product.product_name.length > 25
                        ? product.product_name.slice(0, 25) + '...'
                        : product.product_name}
                    </p>
                    <div className="product-price">
                    <span className="sale-price">
                          {currency} {parseFloat(product.sale_price).toFixed(2)}
                        </span>
                    <span className="old-price">
                          {currency} {parseFloat(product.unit_price).toFixed(2)}
                        </span>
                    </div>
                  </Link>
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SaleSection;
